import { render, staticRenderFns } from "./PAQ.vue?vue&type=template&id=e58e8fcc&scoped=true"
import script from "./PAQ.vue?vue&type=script&lang=js"
export * from "./PAQ.vue?vue&type=script&lang=js"
import style0 from "./PAQ.vue?vue&type=style&index=0&id=e58e8fcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e58e8fcc",
  null
  
)

export default component.exports